/* Publish by EComposer at 2026-10-01 17:16:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1i43o1ww9uw"]=  window.__ectimmers["ecom-1i43o1ww9uw"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-1i43o1ww9uw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1i43o1ww9uw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ge96p3xu4ww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ge96p3xu4ww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ys3k2seiiqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ys3k2seiiqs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-slsw5vuvw1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-slsw5vuvw1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q4f477qtjb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4f477qtjb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ewf4iwd5jir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ewf4iwd5jir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7amkqh72o0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7amkqh72o0t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gykl0kd6ijp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gykl0kd6ijp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n226n23b9o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n226n23b9o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lp870n6mfwf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lp870n6mfwf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a2tztqfxp8k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a2tztqfxp8k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-puhd2ddmfzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-puhd2ddmfzh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b03v823jhj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b03v823jhj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9q99tyqne5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9q99tyqne5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1op9v0y4li4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1op9v0y4li4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ow34uuutzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ow34uuutzo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-19egx1op802').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-19egx1op802', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cvyjtwy4l0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cvyjtwy4l0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ibowmzippu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ibowmzippu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8auas1s1a16').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8auas1s1a16', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7601p78qwzp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7601p78qwzp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r347l1w687r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r347l1w687r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-phpbkmfkusa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phpbkmfkusa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20deyxqzfvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20deyxqzfvs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bdmcsxxx1f9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bdmcsxxx1f9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9giks30dwq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9giks30dwq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kefn3hl9v0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kefn3hl9v0g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wjpeh2fh4rq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wjpeh2fh4rq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6sqbguhixmh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6sqbguhixmh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-70b34wwxtk4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-70b34wwxtk4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4m76w0trt9d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4m76w0trt9d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cxz62e75lor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cxz62e75lor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h5bco7yaqhc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h5bco7yaqhc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uvnh3y9dh6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uvnh3y9dh6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wls94oqppmd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wls94oqppmd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ut94axlqtad').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ut94axlqtad', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0az24rep1zwo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0az24rep1zwo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-euucmw7he8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-euucmw7he8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vqnkpnzg44').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vqnkpnzg44', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5ze3faoybf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5ze3faoybf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-keu99klwrsq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-keu99klwrsq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qjbl2ob1yb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qjbl2ob1yb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-is0roradxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-is0roradxv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4bg3a4oezb7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4bg3a4oezb7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjlcp7c783').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjlcp7c783', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ny1k66hf7e8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ny1k66hf7e8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7pw7kdz3xwi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7pw7kdz3xwi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dfolkwb5f0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dfolkwb5f0o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cmftw70akmg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cmftw70akmg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tp54uo4ob6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tp54uo4ob6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0lw2au6rr4nb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0lw2au6rr4nb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bh18q735j5f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bh18q735j5f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b25zy5c8029').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b25zy5c8029', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a0jaf23golk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0jaf23golk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zavu8qx4h8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zavu8qx4h8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25fa97lt4oo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25fa97lt4oo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-npgukj2h9o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-npgukj2h9o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-153skj3oukt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-153skj3oukt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9moyt8ztcgu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9moyt8ztcgu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-luvhzlvn9h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-luvhzlvn9h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-afm7rvf39b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-afm7rvf39b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yeays6xzii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yeays6xzii', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-c8iluspdyu"]=  window.__ectimmers["ecom-c8iluspdyu"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-c8iluspdyu"]["h40lpeo1w"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-c8iluspdyu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c8iluspdyu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qilnngems1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qilnngems1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wwsqho6smac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wwsqho6smac', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-euhucldeehc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-euhucldeehc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6ut4mj50ng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6ut4mj50ng', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f642xcgxf6p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f642xcgxf6p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jez682cdklj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jez682cdklj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rdr5qiot4ks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rdr5qiot4ks', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ghd4oumwxvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ghd4oumwxvf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4lklb6enzdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4lklb6enzdh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-30nryzhqzmy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-30nryzhqzmy', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ubkyjzd009n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubkyjzd009n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5ztbiaxpzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5ztbiaxpzh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xl1t9aodjc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xl1t9aodjc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwsnz1jywp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwsnz1jywp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x401s0wzsqe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x401s0wzsqe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zjdjn853dks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zjdjn853dks', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ezq7pxvg3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ezq7pxvg3n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-barnjetfwu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-barnjetfwu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47uos8itwbf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47uos8itwbf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m3eoj22ufkr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3eoj22ufkr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9ic3l05cwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9ic3l05cwa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tc1ktqzsmbr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tc1ktqzsmbr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oirlzpjzap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oirlzpjzap', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r3sz1n1tjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r3sz1n1tjs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wn97ts1m9s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wn97ts1m9s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9rhcub1br2s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9rhcub1br2s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nezpyd9atdm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nezpyd9atdm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sui5vy4sle').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sui5vy4sle', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9gbcdisvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9gbcdisvo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0vz0ehrlstac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0vz0ehrlstac', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fgoxur4a539').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fgoxur4a539', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6352ck3kvr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6352ck3kvr', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-palh9kf48w"]=  window.__ectimmers["ecom-palh9kf48w"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-palh9kf48w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-palh9kf48w', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fjumwfyhurp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fjumwfyhurp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q57rm35yy9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q57rm35yy9a', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfnjti6uuic').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfnjti6uuic', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-af3yhnthpfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-af3yhnthpfq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gtimrxkk2ug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gtimrxkk2ug', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0hji97ui8hqp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0hji97ui8hqp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ionklm9m53').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ionklm9m53', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5twowda376t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5twowda376t', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ucl6iex45io').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ucl6iex45io', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b0jh688ttxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b0jh688ttxs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lw1g4k6jzkp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lw1g4k6jzkp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uiz55tqghg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uiz55tqghg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i02pcb3y4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i02pcb3y4t', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ipo36c5coe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ipo36c5coe', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s43wbudowy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s43wbudowy', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9gj3zqa9pu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9gj3zqa9pu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c64jqcy4mxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c64jqcy4mxr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ii41bexmgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ii41bexmgi', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-63d6qftyt47').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-63d6qftyt47', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qpp3l1bmuol').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qpp3l1bmuol', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdmudj9hlzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdmudj9hlzo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9fu3u5rui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9fu3u5rui', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1hxz394ry').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1hxz394ry', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bhku2damebl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bhku2damebl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k28dgb90mx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k28dgb90mx', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24a88rd5fn6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24a88rd5fn6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o0akedro2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o0akedro2f', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-g4c7pgkminv"]=  window.__ectimmers["ecom-g4c7pgkminv"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,o=this.settings.autoplay,n=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const f=t.querySelector(".ecom-element_video-iframe");n&&setTimeout(function(){b(f)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){o&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),o&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-g4c7pgkminv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g4c7pgkminv', settings: {"loop":false,"autoplay":false,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}